import React from "react";
import { IntlProvider } from "react-intl";
import { wrappedDisplayName } from "../IntlRootMixin";
import { getLang, getFormats, getMessages } from "../i18n/i18nDataBuilder";

export function withIntlRootProvider<P>(WrappedComponent: React.ComponentType<P>): React.ComponentType<P> {
    class Wrapper extends React.Component<P> {
        render() {
            return (
                <IntlProvider locale={getLang()} messages={getMessages()} formats={getFormats()}>
                    <WrappedComponent {...this.props} />
                </IntlProvider>
            );
        }

        static readonly displayName = wrappedDisplayName("withIntlRoot", WrappedComponent);
    }

    return Wrapper;
}
